 <form>
 
  <input [formControl]="autoCompleteControl" 
    [placeholder]="defaultServiceName" 
    type="text"  
    [matAutocomplete]="auto" style="width:100%">
 
    <mat-autocomplete autoActiveFirstOption 
      #auto="matAutocomplete" 
      [displayWith]="displayFn" 
      [disableRipple]="true" 
      (optionSelected)="optionSelected($event)" >
       <mat-option *ngFor="let item of autoComplete$ | async; let index = index" [value]="item">
        <div>{{ item.Name }}</div>
      </mat-option>
    </mat-autocomplete>
 
 
</form>
 